module.exports = __webpack_public_path__ + "static/media/csv_more_btn.10cc776b.svg";